import styled from '@emotion/styled';

import { StepHeadline } from './StepHeadline';
import { StepSubHeadline } from './StepSubHeadline';

import type { FunctionComponent } from 'react';

const HeaderContainer = styled.div({
    alignItems: 'flex-start',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-start',
});

type StepHeaderProps = {
    readonly headlineText: string;
    readonly subHeadlineText: string;
};

export const StepHeader: FunctionComponent<StepHeaderProps> = ({ headlineText, subHeadlineText }) => {
    return (
        <HeaderContainer>
            <StepHeadline>{headlineText}</StepHeadline>
            <StepSubHeadline>{subHeadlineText}</StepSubHeadline>
        </HeaderContainer>
    );
};
